import React, { ReactNode } from 'react';
import styled from 'styled-components';
import identityKey from 'identity-keys';
import { colors } from 'bench-style-constants';
import Card from './Card';
const Outside = styled.div`
  margin-top: 4px;
  position: absolute;
  top: 100%;
  z-index: 999;

  ${Card} {
    padding: 8px 16px;
  }
`;
type ValidationProblemProps = {
  children: ReactNode;
};
const StyledValidationProblem = styled.div`
  color: ${colors.copper};
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;
// @TODO - replace with Grid spacing={{paddingBottom:8}}
const Spacer = styled.div`
  margin-bottom: 8px;
`;
export default function ValidationProblem({ children, ...props }: ValidationProblemProps) {
  return (
    <Outside>
      {React.Children.map(children, child => (
        <Spacer key={identityKey(child)}>
          <Card elevation={2}>
            <StyledValidationProblem {...props}>{child}</StyledValidationProblem>
          </Card>
        </Spacer>
      ))}
    </Outside>
  );
}
